import { FC } from 'react'
import type { IconProps } from '../types'

const ClearIcon: FC<IconProps> = props => {
  const { size = 16, color = '#E7E7EA', colorAlt = '#717284' } = props

  // prettier-ignore
  return <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8 -0.00292969C3.584 -0.00292969 0 3.58107 0 7.99707C0 12.4131 3.584 15.9971 8 15.9971C12.416 15.9971 16 12.4131 16 7.99707C16 3.58107 12.416 -0.00292969 8 -0.00292969Z'
      fill={color} />
    <path
      d='M10.7551 5.24201C10.4285 4.91542 9.90091 4.91542 9.57432 5.24201L8 6.81633L6.42568 5.24201C6.09909 4.91542 5.57153 4.91542 5.24494 5.24201C4.91835 5.5686 4.91835 6.09616 5.24494 6.42275L6.81926 7.99707L5.24494 9.57139C4.91835 9.89798 4.91835 10.4255 5.24494 10.7521C5.57153 11.0787 6.09909 11.0787 6.42568 10.7521L8 9.17781L9.57432 10.7521C9.90091 11.0787 10.4285 11.0787 10.7551 10.7521C11.0816 10.4255 11.0816 9.89798 10.7551 9.57139L9.18074 7.99707L10.7551 6.42275C11.0816 6.09616 11.0816 5.5686 10.7551 5.24201Z'
      fill={colorAlt} />
  </svg>
}

export default ClearIcon
